
// 导入axios HTTP请求库
import axios from 'axios';
// 导入Element UI的消息提示组件
import { Message, MessageBox } from 'element-ui';
// 导入token操作相关函数
import { getToken, removeToken} from '@/utils/auth'

// 根据环境设置axios请求的基础URL
if (process.env.NODE_ENV == "development") {
    // 开发环境API地址
    axios.defaults.baseURL = 'http://43.163.86.23:5000/v1';
} else {
    // 生产环境API地址
    axios.defaults.baseURL = 'http://43.163.86.23:5000/v1';
}

// 设置请求超时时间为120秒
axios.defaults.timeout = 120000;

// 请求拦截器：在发送请求前执行
axios.interceptors.request.use(config => {
    // 从本地存储获取访问令牌
    const token = getToken('access_token')
    // 如果令牌存在，将其添加到请求头中
    if (token) {
        config.headers['authorization'] = token
    }
    return config
}, error => {
    // 请求错误处理
    Promise.reject(error)
})


// 响应拦截器：在接收响应后执行
axios.interceptors.response.use(response => {
    /**
     * code:200,接口正常返回;
     */
    // 获取响应数据
    const res = response.data
    // 获取用户语言设置，默认为中文
    let language = getToken('lang') || 'zh'
    
    // 如果状态码不是200，表示请求出错
    if (res.status != 200) {
        // 根据语言选择错误消息
        let message = res.msg
        if(language === 'en') message = res.en_msg;
        
        // 显示错误消息提示
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        
        // 如果状态码是203或204，表示登录失效或未授权
        if (res.status === 203 || res.status === 204 ) {
            // 弹出确认框，提示用户重新登录
            MessageBox.confirm('登录错误，你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 用户点击重新登录，清除所有认证信息
                removeToken('access_token')
                removeToken('isUserAuth')
                removeToken('userInfo')
                removeToken('isAdminAuth')
                // 跳转到登录页
                window.location.href="/login"
            })
        }
        // 返回原始响应数据，即使有错误
        return response.data
    } else { 
        // 状态码为200，正常返回数据
        return response.data
    }
}, error => {
    // 处理响应错误，如网络错误、超时等
    Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
    })
    // 返回错误信息，允许调用者进一步处理
    return Promise.reject(error)
})

// 导出配置好的axios实例，供应用其他部分使用
export default axios
